function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 154.098,
  cy: 230.48,
  r: 153.793,
  transform: "rotate(90.1135 154.098 230.48)",
  fill: "#FFDCD7"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 154.098,
  cy: 230.483,
  r: 77.6456,
  transform: "rotate(90.1135 154.098 230.483)",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.6837 357.913C91.6349 374.099 119.636 383.189 148.465 384.189C150.548 384.372 152.674 384.387 154.827 384.219C175.815 382.581 191.501 364.24 189.863 343.252C188.346 323.803 172.483 308.907 153.464 308.131C110.663 307.951 76.0636 273.155 76.1485 230.332C76.2334 187.449 111.065 152.755 153.948 152.84C196.83 152.925 231.524 187.757 231.439 230.64C231.439 230.901 231.437 231.163 231.434 231.424C231.822 252.044 248.605 268.694 269.342 268.802C290.391 268.912 307.545 251.938 307.655 230.888C307.66 229.951 307.631 229.021 307.569 228.1C307.114 198.796 298.293 170.206 282.114 145.715C265.347 120.335 241.431 100.498 213.391 88.711C185.35 76.9239 154.444 73.7166 124.58 79.4946C94.7164 85.2727 67.2369 99.7765 45.6163 121.172C23.9957 142.568 9.20522 169.894 3.11512 199.696C-2.97497 229.497 -0.0911323 260.435 11.402 288.598C22.8951 316.76 42.4812 340.882 67.6837 357.913Z",
  fill: "#FF745B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M137.032 68.169C141.031 67.3556 142.803 64.1066 142.345 59.7817C142.345 59.7817 138.709 33.5712 116.169 19.6823C93.6282 5.79335 68.1498 14.064 68.1498 14.064C64.326 14.947 61.9647 18.6747 62.8368 22.4513C62.8368 22.4513 66.4731 48.6617 89.0135 62.5507C111.379 75.6843 137.032 68.169 137.032 68.169Z",
  fill: "#6EC686"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M171.168 68.169C167.169 67.3556 165.397 64.1066 165.855 59.7817C165.855 59.7817 169.491 33.5712 192.032 19.6823C214.572 5.79335 240.05 14.064 240.05 14.064C243.874 14.947 246.235 18.6747 245.363 22.4513C245.363 22.4513 241.727 48.6617 219.187 62.5507C196.821 75.6843 171.168 68.169 171.168 68.169Z",
  fill: "#6EC686"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M152.905 249.207C151.925 250.24 151.965 252.241 152.995 253.71C152.995 253.71 160.933 262.713 172.937 262.323C184.94 261.933 201.831 252.425 201.831 252.425C204.33 251.157 204.33 249.54 201.741 247.922C201.741 247.922 184.478 238.919 172.474 239.309C160.726 239.941 152.905 249.207 152.905 249.207Z",
  fill: "#744923"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M149.805 244.012C148.483 245.35 145.839 245.383 143.857 244.085C143.857 244.085 131.631 233.989 131.634 218.125C131.637 202.262 143.867 181.33 143.867 181.33C146.207 177.248 147.48 177.248 149.815 181.257C149.815 181.257 162.041 201.89 162.038 217.753C161.704 233.291 149.805 244.012 149.805 244.012Z",
  fill: "#744923"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 385,
    viewBox: "0 0 309 385",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.0898de7c.svg";
export { ForwardRef as ReactComponent };